// extracted by mini-css-extract-plugin
export var redoItem = "_l2-1";
export var redoTrigger = "_l2-0";